/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue'
import BootstrapVue, { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import MaskedInput from 'vue-text-mask'
import '@/libs/acl/index'
import VueDebounce from 'vue-debounce'
import loading from 'vuejs-loading-screen'
import VueProgressBar from 'vue-progressbar'
import VueMask from 'v-mask'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ErrorHandler from '@/shared/service/errorHandler'
import Confirmacao from './@pilar/plugins/confirmacao'
import Notificacao from './@pilar/plugins/notificacao'

// import 'vue-good-table/dist/vue-good-table.css'

// import { ServerTable, ClientTable } from 'vue-tables-2'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-free/js/all.min'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

Vue.use(CKEditor)

Vue.use(VueProgressBar, {
  color: 'var(--primary)',
  height: '4px',
  speed: '0.6s',
})

Vue.use(VueMask)
Vue.use(Confirmacao)
Vue.use(Notificacao)
Vue.use(ErrorHandler)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(BootstrapVue)
Vue.use(loading, {
  bg: '#f7f7f785',
  icon: 'fas fa-spinner',
  size: 4,
  icon_color: 'var(--primary)',
})

// Vue.use(VueGoodTablePlugin)
// Vue.use(ServerTable, {}, true, 'bootstrap4', 'default')
// Vue.use(ClientTable, {}, false, 'bootstrap4', 'default')

Vue.component('masked-input', MaskedInput)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueDebounce)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// filter para conversão de valor para moeda Real
Vue.filter('converteValor', value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
